export default __webpack_public_path__ + "static/media/887.06c317b2.png";